<template>
  <!-- Update route name to favourites once it exists  -->
  <b-nav-item
    aria-label="navigate to favourites"
    class="nav-item-icon"
    @click="$emit('clicked')"
  >
    <span v-if="isFavouritesMode" class="sr-only"> favourites navigation item active icon filled heart </span>
    <span v-else class="sr-only"> favourites navigation item </span>
    <component
      :is="icon"
      class="md-heroicon text-primary my-auto"
    />
  </b-nav-item>
</template>

<script>
import { HeartIcon } from '@vue-hero-icons/outline'
import { HeartIcon as HeartIconSolid } from '@vue-hero-icons/solid'

export default {
  components: {
    HeartIcon,
    HeartIconSolid
  },

  computed: {
    isFavouritesMode() {
      return this.$route.query.favourites === true || this.$route.query.favourites === 'true'
    },
    icon() {
      return this.isFavouritesMode ? 'heart-icon-solid' : 'heart-icon'
    }
  }
}
</script>
